import { DrawerIds } from "./drawer-ids";

export class DrawerModalAction {
  private id: DrawerIds;
  private showModal: boolean;

  constructor(showmodal: boolean, id: DrawerIds) {
    this.showModal = showmodal;
    this.id = id;
  }

  public build() {
    return {
      showModal: this.showModal,
      id: this.id,
    };
  }
}
